export default __webpack_public_path__ + "static/thebottomline12-7b4c766b058b52aa2ebcb0db8f482e02.jpg";